import { AuthProvider } from './context/AuthContext';
import { MainPage } from './pages';
import { ModalProvider } from './hooks/ModalContext';
import { ContratoProvider } from './context/ContratoContext';
import { CheckBoxCadastroProvider } from './hooks/CheckboxCadastroContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FilaProvider } from './context/FilaContext';
import { FilaProvider as FilaTransbordoProvider } from './context/FilaTransbordoContext';
import { OperadorProvider } from './context/OperadorContext';
import { OperadorCaixaProvider } from './context/OperadorCaixaContext';
import { DividasProvider } from './context/DividasContext';
import { CadastroProvider } from './context/CadastroContext';
import { PropostasProvider } from './context/PropostasContext';
import { BoletoProvider } from './context/BoletoContext';
import { HistoricoProvider } from './context/HistoricoContext';
import { ClearProvider } from './hooks/useClear';
import { ChatWhatsAppProvider } from './context/ChatWhatsAppContext';
import { NegProvider } from './context/NegContext';
import { UsuarioProvider } from './context/Suporte/CadastroUsuarioContext'
import { HibridoProvider } from './context/HibridoContext';
import { WhatsAppCampaignProvider } from './context/WhatsAppCampaignContext'

function App() {
  const clientQuery = new QueryClient({
    defaultOptions: {
      queries: {
        cacheTime: 1000 * 60 * 60 * 24, // 24 hours
      },
    },
  });
  return (
    <>
      <QueryClientProvider client={clientQuery}>
        <AuthProvider>
          <ModalProvider>
            <FilaProvider>
              <FilaTransbordoProvider>
                <WhatsAppCampaignProvider>
                  <OperadorCaixaProvider>
                    <OperadorProvider>
                      <HibridoProvider>
                        <PropostasProvider>
                          <ContratoProvider>
                            <DividasProvider>
                              <NegProvider>
                                <CadastroProvider>
                                  <HistoricoProvider>
                                    <CheckBoxCadastroProvider>
                                      <ChatWhatsAppProvider>
                                        <UsuarioProvider>
                                          <BoletoProvider>
                                            <ClearProvider>
                                              <MainPage />
                                            </ClearProvider>
                                          </BoletoProvider>
                                        </UsuarioProvider>
                                      </ChatWhatsAppProvider>
                                    </CheckBoxCadastroProvider>
                                  </HistoricoProvider>
                                </CadastroProvider>
                              </NegProvider>
                            </DividasProvider>
                          </ContratoProvider>
                        </PropostasProvider>
                      </HibridoProvider>
                    </OperadorProvider>
                  </OperadorCaixaProvider>
                </WhatsAppCampaignProvider>
              </FilaTransbordoProvider>
            </FilaProvider>
          </ModalProvider>
        </AuthProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
